import { Component, inject, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MinervaService } from '../../services/minerva.service';
import { MinervaReportTableVersionComponent } from '../../components/minerva-report/minerva-report-table-version/minerva-report-table-version.component';
import { ThemeService } from '../../services/theme.service';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-minerva-public-panel',
  standalone: true,
  imports: [
    MinervaReportTableVersionComponent,
    CommonModule
  ],
  templateUrl: './minerva-public-panel.component.html',
  styleUrl: './minerva-public-panel.component.scss'
})
export class MinervaPublicPanelComponent implements OnInit {
  activatedRoute = inject(ActivatedRoute);
  themeService = inject(ThemeService);
  minervaService = inject(MinervaService);
  systemType: any;
  qualityChainId: any;
  reportData: any;
  indirectAcquiredData: any;
  enterpriseEmail: string = 'jessica.carmo@qima.com';
  enterpriseAddress: string = 'R. Dr. Arthur Jorge, 1223 - Sl 03 - Centro, Campo Grande - MS, 79002-450';
  corporateName: string = '';
  signatureData: string = ''

  ngOnInit(): void {
    sessionStorage.clear();
    localStorage.clear();
    this.activatedRoute.paramMap.subscribe(params => {
      this.systemType = params.get('systemType')!;
    });
    if (this.systemType == 'SAFETRACE') {
      this.themeService.setThemeByThemeName('SAFETRACE');
    } else {
      this.enterpriseEmail = 'rastreabilidade.tecnico@qima.com';
      this.signatureData = `Roberta Campos da Cunha - ${this.enterpriseEmail}`;
    }
  }

  saveReportData(event: any): void {
    this.reportData = event;
  }

  saveCorporateName(event: any): void {
    this.corporateName = event;
  }

  downloadReport(): void {
    if (!this.reportData || this.reportData.length === 0) {
      console.error('Nenhum dado disponível para exportação.');
      return;
    }

    const headers = [
      'Identificação Animal', 'Raça', 'Sexo', 'Maturidade',
      'Data de Nascimento', 'Data de Brincagem', 'Classificação', 'INL'
    ];

    const csvData = this.reportData.map((row: any) => [
      `\t${row.animalId}`, row.breed, row.sex, row.maturity,
      row.birth, row.earring, row.rating, row.auction
    ].map(value => `"${(value || '').toString().replace(/"/g, '""')}"`).join(';'));

    const csvContent = [headers.join(';'), ...csvData].join('\n');

    const bom = '\uFEFF';
    const blob = new Blob([bom + csvContent], { type: 'text/csv;charset=utf-8;' });

    const link = document.createElement('a');
    const url = URL.createObjectURL(blob);
    link.setAttribute('href', url);
    link.setAttribute('download', `${this.corporateName} - ${this.getDate()}`);
    link.style.visibility = 'hidden';

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }

  getDate(date?: Date) {
    const data = date ? new Date(date) : new Date();
    const dia = data.getUTCDate();
    const mes = data.getUTCMonth() + 1;
    const ano = data.getUTCFullYear();
    const dataFormatada = `${dia < 10 ? '0' + dia : dia}/${mes < 10 ? '0' + mes : mes}/${ano}`;
    return dataFormatada;
  }
}